<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form ref="searchForm">
                    <c-form-item v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'"
                                 type="select" label="运营模式" name="operation_mode"
                                 :options="operationMode"></c-form-item>
                    <c-form-item v-if="systemConfig.pt_mode == 2" type="hidden" name="stationed_id"></c-form-item>
                    <c-form-item v-if="systemConfig.pt_mode == 2" type="input" label="所属商家" name="company_name"
                                 readonly @click="$refs.stationedSelector.open()" clear-button
                                 @clear="$refs.searchForm.set({stationed_id: '', company_name: ''})"></c-form-item>
                    <c-form-item type="input" label="服务名称" name="product_name" placeholder="模糊匹配名称、货号"></c-form-item>
                    <!-- <c-form-item v-if="systemConfig.share_enable == 'ON'" type="select" label="销售模式" name="sales_model" :options="searchSalesModelOptions"></c-form-item> -->
                    <c-form-item v-if="systemConfig.share_enable == 'ON'" type="checkbox" label="可售范围" name="visible_user_level" :options="userLevelOptions"></c-form-item>
                    <c-form-item v-if="systemConfig.is_outstock == 'ON'" type="checkbox" label="缺货订购" name="outstocks" :options="isOutstockData"></c-form-item>
                    <c-form-item type="select" label="服务类目" name="product_type_id" options="PRODUCT_CLASSIFY"></c-form-item>
                    <c-form-item type="datetime" label="上下架时间" start-name="sell_state_start_date" end-name="sell_state_end_date"></c-form-item>
                    <c-form-item type="checkbox" label="服务状态" name="state" :options="productState"></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button power="b_product_audit_list_audit" color="sys" @click="batchAudit(1)">批量审核</c-button>
                <!-- <c-button power="b_product_audit_list_audit" color="black" hollow @click="batchAudit(2)">批量设置销售模式</c-button> -->
                <!-- <c-button power="b_product_audit_list_audit" color="black" hollow @click="batchAudit(3)">批量设置可售范围</c-button> -->
            </m-operate>

            <c-table ref="table">
                <c-table-column type="selector"></c-table-column>

                <c-table-column
                        label="状态"
                        name="state"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state == 0" style="color:red">{{ productStateName[data.state] }}</span>
                        <span v-if="data.state == 1" style="color:#999999">{{ productStateName[data.state] }}</span>
                        <span v-if="data.state == 2" style="color:green">{{ productStateName[data.state] }}</span>
                        <span v-if="data.state == 3" style="color:blue">{{ productStateName[data.state] }}</span>
                        <span v-if="data.state == 4" style="color:red">{{ productStateName[data.state] }}
                         <c-tooltip :tip="data.reject_reason" style="margin-left: 3px;"></c-tooltip>
                        </span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="运营模式"
                        name="operation_mode"
                        width="80"
                        v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'"
                >
                    <template v-slot="{data}">
                        {{ operationModeName[data.operation_mode] }}
                    </template>
                </c-table-column>

                <c-table-column
                        label="商家角色"
                        name="stationed_auth_name"
                        width="110"
                        v-if="systemConfig.pt_mode == 2 && systemConfig.stationed_authname_enabled == 'ON'"
                >
                </c-table-column>

                <c-table-column
                        label="商家名称"
                        name="stationed_name"
                        width="150"
                        v-if="systemConfig.pt_mode == 2"
                ></c-table-column>

                <c-table-column
                        label="服务信息"
                        name="product_name"
                        width="350"
                >
                    <template v-slot="{data}">
                        <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                        <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                    </template>
                </c-table-column>
				
				<c-table-column
				        label="可售区域"
				        width="400"
				        name="region_names"
				>
				    <template #default="{data}">
				        <span v-if="data.region_type == 1" style="color:green">全国可售</span>
						<span v-if="data.region_type == 2">{{data.region_names}}</span>
						<span v-if="data.region_type == 3">全国可售，以下地区除外（<span style="color:red">{{data.region_names}}</span>）</span>
				    </template>
				</c-table-column>

                <!-- <c-table-column
                        label="销售模式"
                        width="80"
                        name="sales_model"
                        v-if="systemConfig.share_enable == 'ON'"
                >
                    <template #default="{data}">
                        <span v-if="data.sales_model == 1" style="color:blue">供货</span>
                        <span v-else-if="data.sales_model == 2" style="color:darkgreen">直销</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column> -->

                <!-- <c-table-column
                        label="可售范围"
                        width="80"
                        name="visible_user_level_name"
                        v-if="systemConfig.share_enable == 'ON'"
                >
                    <template #default="{data}">
                        <span v-if="data.visible_user_level_name && data.visible_user_level_name == '全部用户'" style="color:blue">全部用户</span>
                        <span v-else v-for="(item, i) in data.visible_user_level_name.split(',')" :key="i" style="color:darkslategrey">{{item}}</span>
                    </template>
                </c-table-column> -->

                <c-table-column
                        label="定制"
                        width="60"
                        name="is_custom"
                        v-if="systemConfig.product_custom == 'ON'"
                >
                    <template #default="{data}">
                        <span v-if="data.is_custom == 1" style="color:blue">支持</span>
                        <span v-else style="color:#999">不支持</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="服务类目"
                        name="product_type_full_name"
                        width="220"
                >
                    <template v-slot="{data}">
                        <span v-if="systemConfig.is_virtual_product == 'ON' && data.is_virtual == 0">[实物]</span>
                        <span v-if="systemConfig.is_virtual_product == 'ON' && data.is_virtual == 1" style="color:blue">[虚拟]</span>
                        {{data.product_type_full_name}}
                    </template>
                </c-table-column>

                <!-- <c-table-column
                        label="供应价(元)"
                        name="product_cost_price"
                        width="140"
                >
                    <template v-slot="{data}">
                        ￥{{ data.product_cost_price }}
                    </template>
                </c-table-column> -->

                <c-table-column
                        label="售价(元)"
                        name="product_price"
                        width="95"
                >
                    <template v-slot="{data}">
                        <span v-if="data.price_modue == 1">
                            ￥{{ data.product_price }}
                        </span>
                        <span v-else style="color: blue">
                            价格面议
                        </span>
                    </template>
                </c-table-column>
				
				<c-table-column
					label="价格单位"
					name="price_unit"
					width="80"
				>
					<template v-slot="{data}">
						{{data.price_unit || '-'}}
					</template>
				</c-table-column>

                <c-table-column
                        label="更新时间"
                        name="update_date"
                        width="140"
                ></c-table-column>

                <c-table-column
                        label="上下架时间"
                        name="sell_state_date"
                        width="140"
                ></c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="70"
                >
                    <template v-slot="{data}">
                        <c-table-button power="b_product_audit_list_audit" @click="navigateTo(`/product_detail/${data.product_id}`)">{{ data.state == 3 ? '审批' : '查看' }}</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>

        <!--多服务-->
        <c-dialog ref="batchAuditDialog" title="批量审核" width="500" @resolve="batchAuditHandle">
            <c-form ref="batchAuditForm">
                <c-form-item  v-if="this.auditEditType == 1" type="radio" label="审核结果" name="state" v-model="auditState" :options="auditStateOptions" required></c-form-item>
                <c-form-item  v-if="this.auditEditType == 1 && auditState == 2" type="select" label="驳回原因" name="reject_reason" required options="PRODUCT_REJECT_REASON"
                             word="请选择驳回该服务的原因"></c-form-item>
                <c-form-item  v-if="this.auditEditType == 1 && auditState == 2" type="textarea" label="备注" name="reject_reason_remark"
                             word="请输入驳回原因的备注信息，该信息将附加在驳回原因之后，最多可输入100个字符" maxlength="100"></c-form-item>
            </c-form>
        </c-dialog>

        <stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
    </page>
</template>

<script>
import productInfo from '@/components/public/product_info.vue'
import stationedSelector from '@/components/service/stationed_selector.vue'  // 商家库
import {mapState} from 'vuex'

export default {
    name: 'm_product_audit_list',

    components: {
        productInfo,
        stationedSelector
    },

    data() {
        return {
            productState: [
                {name: '草稿',value: 0},
                {name: '上架',value: 2},
                {name: '下架',value: 1},
                {name: '待审核',value: 3},
                {name: '已驳回',value: 4}
            ],
            operationMode: [
                {name: '平台自营', value: 1},
                {name: '商家自营', value: 2},
                {name: '采购供货', value: 3}
            ],
            operationModeName: {
                1: '平台自营',
                2: '商家自营',
                3: '采购供货'
            },
            auditStateOptions: [
                {name: '审核通过',value: 1},
                {name: '审核驳回',value: 2},
            ],
            auditState: 1,
            productClassify: [
                [], [], []
            ],
            currentClassify: [],
            classifySearch: [],
            currentClassifyId: '',
            flushImportHisTableTimer: null,
            productTagList: [],
            currentProductTag: [],
            auditType: '',
            isCustom: 0,
            salesModel:undefined,
            salesModelOptions: [
                {name: '供货',value: 1},
                {name: '直销',value: 2}
            ],
            searchSalesModelOptions: [
                {name: '未设置',value: -1},
                {name: '供货',value: 1},
                {name: '直销',value: 2}
            ],
            isOutstockData: [
                {name: '支持',value: '2'},
                {name: '不支持',value: '1'}
            ],
            userLevelOptions: [],
            /**
             * 是否需要设置【销售模式】，仅首次审批的服务需要设置销售模式
             * 0:所有服务均非首次审批，无需设置【销售模式】
             * 1:部分服务是首次审批，需要设置【销售模式】
             * */
            setSalesModel:0,
            productAuditSupplierTitle:'服务售价调整',
            auditEditType:1//批量处理方式  1=审批 2=设置销售模式 3=设置可售范围
        }
    },

    computed: {
        ...mapState(['systemConfig']),
        ...mapState({
            productStateName: state => state.dict.productState
        }),
        defaultSearch() {
            let param = {
                state: [3],
            }
            return param;
        }
    },

    mounted() {
        this.initUserLevelOptions();
        //搜索条件默认设置为：待审核
        this.$refs.searchForm.set(this.defaultSearch);
        this.$nextTick(() => {
            this.$refs.search.search();
        })

        this.$bus.$on('productAuditList.update', page => {
            this.$refs.table.update(page);
        });
    },

    methods: {
        searchHandle(data) {
            this.$refs.table.load({
                url: '/product/list',
                data: Object.assign(data, {audit_product: 1})
            });
        },

        //加载用户等级列表
        initUserLevelOptions(){
            this.request({
                url: '/user_level/options',
                data: {},
                success: data => {
                    this.userLevelOptions = Array.from(data, item => {
                        return {
                            name: item.name,
                            value: item.value
                        }
                    });
                }
            });
        },

        selectStationed(data) {
            this.$refs.searchForm.set({
                stationed_id: data[0].id,
                company_name: data[0].company_name
            });
        },

        //批量审核弹框
        batchAudit(type) {
            this.auditEditType = type;
            this._auditProductIds = [];
            //批量操作
            var list = this.$refs.table.getRow('selected');
            if (!list.length) {
                this.$message({
                    text: '请选择要处理的服务'
                });
                return;
            }
            var flag = true;
            list.forEach((item, index, array)=>{
                if (this.auditEditType == 1 && item.data.state != 3) {
                    flag = false;
                }else if (this.auditEditType == 2 && item.data.sales_model){
                    flag = false;
                }
                if (!item.data.sales_model) {
                    this.setSalesModel = 1;
                }
            });


            if (this.auditEditType == 1 && !flag) {
                this.$message({
                    text: '只能选择待审核的服务进行审核，请重新选择！'
                });
                return false;
            }else if (this.auditEditType == 2 && !flag) {
                this.$message({
                    text: '只能选择尚未设置销售模式的服务，请重新选择！'
                });
                return false;
            }

            this._auditProductIds = Array.from(list, item => {
                return item.data.product_id;
            })

            this.$refs.batchAuditForm.clear();
            this.$refs.batchAuditForm.set({state: 1});
            this.$refs.batchAuditDialog.open();
        },
        //批量审核提交
        batchAuditHandle(stop) {
            stop();
            //this.$refs.editProductSkuPrice.open(item);
            this.$confirm({
                text: '是否确认【'+(this.auditState == 1?'审批通过':'审批驳回')+'】选中的【'+this._auditProductIds.length+'】项服务？',
                resolve: () => {
                    this.$refs.batchAuditForm.submit({
                        url: '/product/batchAudit',
                        rule: {
                            // sales_model: [{
                            //     type: 'empty',
                            //     skip: () => {
                            //         return this.auditEditType == 3 || this.auditState == 2 || this.systemConfig.share_enable == 'OFF' || this.setSalesModel == 0;
                            //     },
                            //     word: '请选服务择销售模式'
                            // }],
                            // visible_user_level: [{
                            //     type: 'empty',
                            //     skip: () => {
                            //         return this.auditEditType == 2 || this.auditState == 2 || this.systemConfig.share_enable == 'OFF';
                            //     },
                            //     word: '请选择服务的可售范围'
                            // }],
                            /*add_product_ratio: [{
                                type: 'empty',
                                skip: () => {
                                    return this.auditEditType != 1 || this.auditState == 2;
                                },
                                word: '请填写服务加价比例'
                            }],
                            add_custom_money: [{
                                type: 'empty',
                                skip: () => {
                                    return this.auditEditType != 1 || this.systemConfig.product_custom == 'OFF' || this.auditState == 2;
                                },
                                word: '请填写定制加价金额(单项)'
                            }],*/
                            reject_reason: [{
                                type: 'empty',
                                skip: () => {
                                    return this.auditEditType != 1 || this.auditState == 1;
                                },
                                word: '请填写驳回原因'
                            }],

                        },
                        dataFormatter: data => {
                            var reject_reason = data.reject_reason;
                            if (data.reject_reason_remark && data.reject_reason_remark.trim()!=''){
                                reject_reason += '（';
                                reject_reason += data.reject_reason_remark.trim();
                                reject_reason += '）';
                            }
                            /**
                             * 1 = 审核服务
                             * 2 = 批量设置销售模式
                             * 3 = 批量服务可售范围
                             * */
                            data.auditEditType = this.auditEditType;
                            //data.visible_user_level = data.visible_user_level.join(',');
                            data.add_custom_money = data.add_custom_money||0;
                            data.add_product_ratio = data.add_product_ratio||0;
                            data.add_custom_money = data.add_custom_money||0;
                            data.reject_reason = reject_reason;
                            return Object.assign(data, {
                                product_ids: this._auditProductIds,
                                audit_type: this.auditState
                            });
                        },
                        success: (data, res) => {
                            var tipMessage = "批量审核驳回成功";
                            if (this.auditState != 2) {
                                if (this.auditEditType == 1){
                                    tipMessage = "批量审核通过成功";
                                }else if (this.auditEditType == 2){
                                    tipMessage = "批量设置销售模式";
                                }else if (this.auditEditType == 3){
                                    tipMessage = "批量设置可售范围成功";
                                }
                            }
                            this.$message({
                                text: tipMessage,
                                icon: 'success'
                            });
                            this.$refs.table.update();
                            this.$refs.batchAuditDialog.close();
                        }
                    });
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.classify-select {
    padding: 10px;

    dl {
        width: 240px;
        border: 1px solid #ddd;

        &:nth-child(n+2) {
            border-left: none;
        }

        dt {
            position: relative;
            padding: 10px;

            .tf {
                position: absolute;
                width: 30px;
                line-height: 36px;
                font-size: 14px;
                text-align: center;
                color: #bbb;
            }

            input {
                box-sizing: border-box;
                width: 100%;
                height: 36px;
                border: none;
                padding: 0 10px 0 30px;
                background: #F5F5F5;
            }
        }

        dd {
            height: 290px;
            overflow: auto;

            li {
                padding: 0 14px;
                line-height: 36px;
                font-size: 13px;
                cursor: pointer;

                &:hover,
                &.z-crt {
                    background: #FFF17E;
                }
            }
        }
    }
}

.tag {
    &-list {
        padding: 20px 20px 20px 10px;
    }

    &-item {
        margin-left: 10px;
    }

    &-img {
        height: 20px;
    }

    &-text {
        border: 1px solid #000;
        padding: 0 6px;
        line-height: 18px !important;
        font-size: 12px;
        font-weight: normal !important;
        color: #000;
    }
}
</style>